<script setup lang="ts">
import { ErrorMessage, useField } from 'vee-validate'

const props = defineProps<{
  id?: string
  name: string
  min: number
  max: number
  step: number
  label?: string
  description?: string
  unit?: string
  disabled?: boolean
}>()
// TODO: Check error message
const { value, errorMessage } = useField(() => props.name)
</script>

<template>
  <div class="mb-1 w-full">
    <div class="flex justify-between mb-2 items-center">
      <label v-if="label" class="md:text-base font-medium">{{ label }}</label>
      <div
        class="text-xs md:text-base max-w-[20%] min-w-fit bg-indigo-200 rounded-md flex items-center justify-end h-8 px-2 py-1"
      >
        <input
          type="number"
          v-model="value"
          :disabled="disabled ?? false"
          :class="{
            'crowdy-number-input-for-range focus:ring-0': true,
            'outline-none outline-offset-5 focus:outline-none focus:outline-offset-5': true,
            'border-none focus:border-none': true,
            'w-10 md:w-24 text-xs md:text-base bg-transparent text-center text-gray-700 min-w-16': true

          }"
          class=""
        />
        {{ unit }}
      </div>
    </div>
    <p v-if="description" class="text-xs md:text-base text-left text-gray-500 mb-2">
      {{ description }}
    </p>
    <input
      type="range"
      v-model="value"
      :disabled="disabled ?? false"
      :min="min"
      :max="max"
      :step="step"
      class="w-full mt-2.5"
      />
    <ErrorMessage :name="name" class="text-xs md:text-base font-thin text-red-400" />
  </div>
</template>
<style scoped>
.crowdy-number-input-for-range::-webkit-outer-spin-button,
.crowdy-number-input-for-range::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.crowdy-number-input-for-range {
  -moz-appearance: none;
}
</style>
